var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2882)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35601 0.654134C3.54601 -0.213866 4.78301 -0.219866 4.98101 0.647134L4.99101 0.691134L5.01101 0.777134C5.13179 1.29099 5.40091 1.75803 5.78494 2.12019C6.16897 2.48235 6.65096 2.72366 7.17101 2.81413C8.07601 2.97113 8.07601 4.27113 7.17101 4.42813C6.64803 4.5191 6.16359 4.76261 5.77857 5.12806C5.39355 5.49351 5.12512 5.9646 5.00701 6.48213L4.98101 6.59513C4.78301 7.46213 3.54701 7.45613 3.35601 6.58813L3.33601 6.49113C3.22229 5.97186 2.95648 5.49823 2.5725 5.13063C2.18851 4.76303 1.70375 4.51812 1.18001 4.42713C0.276014 4.26913 0.276014 2.97313 1.18001 2.81513C1.70175 2.72437 2.18483 2.48085 2.56809 2.11539C2.95135 1.74993 3.21756 1.27897 3.33301 0.762134L3.34901 0.691134L3.35601 0.654134ZM11.136 3.61613C11.4131 3.49979 11.7186 3.46934 12.0132 3.52871C12.3078 3.58808 12.5777 3.73455 12.788 3.94913L12.79 3.95013L14.056 5.22713C14.196 5.36651 14.3071 5.53216 14.3829 5.71458C14.4587 5.897 14.4977 6.09259 14.4977 6.29013C14.4977 6.48767 14.4587 6.68327 14.3829 6.86569C14.3071 7.04811 14.196 7.21376 14.056 7.35313L14.054 7.35513L7.85701 13.5921C7.77359 13.6762 7.66302 13.728 7.54501 13.7381L4.54501 13.9981C4.4724 14.0044 4.39929 13.9947 4.33082 13.9697C4.26234 13.9447 4.20016 13.9051 4.14862 13.8535C4.09708 13.802 4.05744 13.7398 4.03246 13.6713C4.00748 13.6029 3.99777 13.5298 4.00401 13.4571L4.26401 10.4571C4.27419 10.3391 4.32593 10.2286 4.41001 10.1451L10.647 3.94813C10.7861 3.80624 10.953 3.69339 11.136 3.61613Z",
    fill: "#273848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconDark);
export default __webpack_public_path__ + "static/media/AiIconDark.1e410ff783795b20398f2836cc812cef.svg";
export { ForwardRef as ReactComponent };